import React, { useCallback, useContext, useMemo, useRef } from 'react'
import { Col, Row, Card, Form, Container, Button, InputGroup } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '../index'

const _FilterForm = ({ region }) => {

  const { state, dispatch } = useContext(Context);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);
  const _email = useRef(state.filter.email);
  const _id = useRef(state.filter.id);
  const _status = useRef(state.filter.status);
  const _paymentMethod = useRef(state.filter.paymentMethod);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeEmail = useCallback((payload) => {
    _email.current = payload.target.value
  }, [])

  const _handleChangeId = useCallback((payload) => {
    _id.current = payload.target.value
  }, [])

  const _handleChangeStatus = useCallback((payload) => {
    _status.current = payload.target.value
  }, [])

  const _handleChangePaymentMethod = useCallback((payload) => {
    _paymentMethod.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current,
        id: _id.current,
        status: _status.current,
        email: _email.current,
        paymentMethod: _paymentMethod.current,
      }
    })
  }, [dispatch])

  const _changeFilterMethod = useCallback((method) => {
    dispatch({
      type: 'CHANGE_FILTER_METHOD',
      payload: {
        method: method
      }
    })
  }, [dispatch])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>Đơn mua vé</h5>
            </Col>
            <Col className='text-left'>
              <Button
                style={{ marginRight: 20 }}
                variant="success"
                disabled={state.filter.method === 'BY_ID'}
                type="submit"
                onClick={() => _changeFilterMethod('BY_ID')}>
                Tìm theo mã đơn
              </Button>
            </Col>
            <Col className='text-left'>
              <Button
                style={{ marginRight: 20 }}
                variant="warning"
                disabled={state.filter.method === 'BY_CONDITION'}
                type="submit"
                onClick={() => _changeFilterMethod('BY_CONDITION')}>
                Tìm theo điều kiện
              </Button>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
            </Col>
          </Row>
        </Card.Header>
        {state.filter.method === 'BY_CONDITION' ?
          <Card.Body>
            <Container>
              <Col>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Từ ngày</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          initialValue={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                          onChange={_handleChangeFrom}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Đến ngày</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          timeFormat={false}
                          onChange={_handleChangeTo}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Số điện thoại</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại" />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Email</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Control onChange={_handleChangeEmail} required type="text" placeholder="Nhập email" />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Trạng thái</Form.Label>
                      </Col>
                      <Col md={9}>
                      <Form.Select onChange={_handleChangeStatus}>
                        <option defaultValue value={''}>Tất cả</option>
                        <option value={'0'}>Chưa thanh toán</option>
                        <option value={'1'}>Đã thanh toán</option>
                      </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Thanh toán</Form.Label>
                      </Col>
                      <Col md={9}>
                      <Form.Select onChange={_handleChangePaymentMethod}>
                        <option defaultValue value={''}>Tất cả</option>
                        <option value={'ZALOPAY'}>ZALOPAY</option>
                        <option value={'BANKING'}>BANKING</option>
                      </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Container>
          </Card.Body>
          :
          <Card.Body>
            <Container>
              <Col>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Mã đơn</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Control onChange={_handleChangeId} required type="text" placeholder="Nhập mã đơn" />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Container>
          </Card.Body>
        }
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)